import { Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../helper/PermissionContext";
import AccessDenied from "../pages/AccessDenied/AccessDenied";

// Route path -> permission slug required to open it.
// Add/edit sub-routes inherit their parent module's permission.
const ROUTE_PERMISSIONS = {
  "/": "dashboard",
  "/home": "home-management",
  "/blog": "blog-management",
  "/add-blog": "blog-management",
  "/edit-blog": "blog-management",
  "/category": "blog-management",
  "/author": "blog-management",
  "/project": "project-management",
  "/add-project": "project-management",
  "/edit-project": "project-management",
  "/project-category": "project-management",
  "/job": "career-management",
  "/add-job": "career-management",
  "/edit-job": "career-management",
  "/location": "career-management",
  "/department": "career-management",
  "/seo": "seo-management",
  "/add-seo": "seo-management",
  "/edit-seo": "seo-management",
  "/global-seo": "global-seo",
  "/sitemap": "sitemap-management",
  "/llms": "llms-management",
  "/robots": "robots-management",
  "/faq": "faq-management",
  "/add-faq": "faq-management",
  "/edit-faq": "faq-management",
  "/testimonial": "testimonials",
  "/client-logo": "client-logos",
  "/we-work": "how-we-work",
  "/stats": "our-stats",
  "/contact": "contact-us",
  "/partner-with-us": "partner-with-us",
  "/job-applications": "job-applications",
  "/referral": "pms-referral",
  "/landing-page": "landing-page",
  "/dynamic": "dynamic-page",
  "/add-dynamic": "dynamic-page",
  "/edit-dynamic": "dynamic-page",
  "/email-management": "email-management",
  "/add-email-management": "email-management",
  "/edit-email-management": "email-management",
  "/users": "user-management",
  "/roles": "user-management",
  "/permissions": "user-management",
};

// Match by path segments so "/blog" never matches "/blog-management" etc.
const permissionForPath = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return ROUTE_PERMISSIONS["/"];
  for (const [key, slug] of Object.entries(ROUTE_PERMISSIONS)) {
    if (key === "/") continue;
    const keySegments = key.split("/").filter(Boolean);
    if (keySegments.every((segment, index) => segments[index] === segment)) return slug;
  }
  return null; // unknown route -> no restriction
};

// Guards the <Outlet />: blocks routes the current user has no permission for.
const RoutePermissionGuard = () => {
  const { pathname } = useLocation();
  const { status, hasPermission } = usePermissions();
  const required = permissionForPath(pathname);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  if (required && !hasPermission(required)) {
    return <AccessDenied />;
  }

  return <Outlet />;
};

export default RoutePermissionGuard;
